// /src/router/router.js
import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'
import Resources from '@/views/Resources.vue'
import Bookmarks from '@/views/Bookmarks.vue'
import UserLogin from '@/views/UserLogin.vue'
import Search from '@/views/Search.vue'
import Course from '@/views/Course.vue'
import Sessions from '@/views/Sessions.vue'
import Courses from '@/views/Courses.vue'
import Session from '@/views/Session.vue'
import Relationship from '@/views/Relationship.vue'
import Relationships from '@/views/Relationships.vue'
import Directory from '@/views/Directory.vue'
import FunnelLanding from '@/views/FunnelLanding.vue'
import PdfViewer from '@/views/PdfViewer.vue'
import store from '@/store/store'

import create from 'lodash/create'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to) {
    document.body.scrollTop = 0 // For Safari
    const scrolltoHash = to.meta.scrollTo ? to.meta.scrollTo : (to.hash ? to.hash.replace('#', '') : 'header')
    return {
      selector: scrolltoHash,
      behavior: 'smooth',
    }
  },
  routes: [
    {
      path: '/sessions/:slug',
      name: 'session',
      meta: {
        title: 'Session',
        routePath: 'sessions',
      },
      component: Session,
    },
    {
      path: '/dashboard/:slug',
      name: 'dashboards',
      meta: {
        title: 'Dashboard',
      },
      component: Dashboard,
    },
    {
      path: '/relationships',
      name: 'relationships',
      meta: {
        title: 'Relationships',
        routePath: 'relationships',
      },
      component: Relationships,
    },
    {
      path: '/',
      name: 'dashboard',
      meta: {
        title: 'Dashboard',
      },
      component: Dashboard,
    },
    // {
    //   path: '/resources',
    //   name: 'resources',
    //   meta: {
    //     title: 'Resources',
    //     routePath: 'resources',
    //   },
    //   component: Resources,
    // },
    {
      path: '/directory',
      name: 'directory',
      meta: {
        title: 'Directory',
      },
      component: Directory,
    },
    {
      path: '/bookmarks',
      name: 'bookmarks',
      meta: {
        title: 'Bookmarks',
      },
      component: Bookmarks,
    },
    {
      path: '/search',
      name: 'search',
      meta: {
        title: 'Search',
        routePath: 'search',
      },
      component: Search,
    },
    {
      path: '/courses',
      name: 'courses',
      meta: {
        title: 'Courses',
        routePath: 'courses',
      },
      component: Courses,
    },
    {
      path: '/pdf-viewer',
      name: 'pdfViewer',
      props: true,
      meta: {
        title: 'PDF Viewer',
      },
      component: PdfViewer,
    },
    {
      path: '/funnel-landing/:slug',
      name: 'funnelLanding',
      meta: {
        title: 'Funnel Page',
      },
      component: FunnelLanding,
    },
    // {
    //   path: '/bible-studies/:slug',
    //   name: 'bibleStudy',
    //   meta: {
    //     title: 'Bible Study',
    //   },
    //   component: BibleStudy,
    // },
    {
      path: '/relationships/:slug',
      name: 'relationship',
      meta: {
        title: 'Relationship',
        routePath: 'relationships',
      },
      component: Relationship,
    },
    {
      path: '/courses/:slug',
      name: 'course',
      meta: {
        title: 'Course',
        routePath: 'courses',
      },
      component: Course,
    },
    {
      path: '/sessions',
      name: 'sessions',
      meta: {
        title: 'Sessions',
        scrollTo: 'header',
        routePath: 'sessions',
      },
      component: Sessions,
    },
    {
      path: '/sign-in',
      name: 'user-login',
      component: UserLogin,
      meta: { 
        requiresAuth: false,
        title: 'Login',
      },
    },

  ],
})

// console.log(window.location.pathname)

function setQueryParams(query, to) {

  if ((to.query).hasOwnProperty('sort')) {
    const sortby = to.query.sort.replace('-', '')

    query.orderby = sortby == 'post_title' ? 'title' : sortby
    if (to.query.sort[0] === '-') {
      query.order = 'desc'
    } else {
      query.order = 'asc'
    }

  } else {
    query.orderby = typeof query['orderby'] != 'undefined' ? query['orderby'] : 'menu_order'
    query.order = typeof query['order'] != 'undefined' ? query['order'] : 'asc'
  }

  delete query.sort

  return query

}

router.beforeEach((to, from, next) => {
  // console.log(to.name)
  // set router so that by default everything requires auth
  store.dispatch('closeMenu')

  if (typeof to.meta.requiresAuth == 'undefined') {
    if (store.getters['user/authCheck']) {
      if (from.name == null || from.name == 'user-login') { // limits api requests to only happen upon refresh or coming into a page
        store.dispatch('options/getAll')
        store.dispatch('taxies/compileUserGroups')
        store.dispatch('posts/runSearch')
        // store.dispatch('media/getAll')
      } 
      if (to.path !== from.path && (to.name == 'session' || to.name == 'course' || to.name == 'relationship')) {
        // console.log('getting post')
        store.dispatch('posts/getPost', { slug: to.params.slug, routePath: to.meta.routePath }, false)
      } else if (to.name == 'sessions' || to.name == 'courses' || to.name == 'relationships') {
        // console.log('getting posts')
        let query = create({ }, to.query)
        query = setQueryParams(query, to)

        if (to.name == 'relationships') query['per_page'] = typeof query['per_page'] != 'undefined' ? query['per_page'] : 32
        
        store.dispatch('posts/getPostLists', { query, routePath: to.meta.routePath })
      } else if (to.name == 'dashboard') {
        store.dispatch('posts/getDashboards', { slug: to.path })
      } else if (to.name == 'bookmarks') {
        let query = create({}, to.query)
        store.dispatch('posts/getBookmarks', { ...query })
      } else if (to.name == 'search') {
        // store.dispatch('posts/runSearch', { ...to.query })
      } else {
        // console.log('getting all posts')
        // store.dispatch('posts/getAll')
      }


      next()
    } else {
      next({
        name: 'user-login',
        query: { loginRedirect: to.fullPath },
      })
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
// sets up backButton tracking
  if (!store.getters['backButtonClicked']) {
    // keeps sign in page from being included in route history
    if (!(to.name == 'user-login' && from.name == null)) store.dispatch('updateRouteHistory', to)
  } else {
    // fixes bug created by backButton loop
    store.dispatch('removeLastFromRouteHistory')
    store.dispatch('isBackButtonClicked', false)
  }
})

export default router
